import Chip from "@mui/material/Chip";
import styled from "@mui/material/styles/styled"; // STYLED COMPONENT

const StyledChip = styled(Chip)(({ theme }) => ({
  zIndex: 1,
  fontWeight: 600,
  fontSize: "12px",
  position: "absolute",
  color: theme.palette.common.white,
  background: theme.palette.custom.coral,
  borderRadius: "2px",
  borderTopLeftRadius: "inherit",
})); // ==============================================================

// ==============================================================
const DiscountChip = ({ discount = 0, ...props }) => {
  return discount > 0 ? <StyledChip size="small" label={`Sale ${discount}%`} {...props} /> : null;
};

export default DiscountChip;
